// project hash key
// e921d896b24ee51ad95dc303a034758da1187532b0a44189bd99aa333255781b

import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import IconPrevArrow from '../../../../assets/imgs/lotteryDetail/chevron_left.png';
import IconNextArrow from '../../../../assets/imgs/lotteryDetail/chevron_right.png';

function NextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={`my-next-arrow  ${className}`}
      style={{
        ...style,
        display: 'block',
        background: `url(${IconNextArrow}) no-repeat`,
        backgroundSize: 'contain',
      }}
      onClick={onClick}
    />
  );
}

function PrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={`my-prev-arrow  ${className}`}
      style={{
        ...style,
        display: 'block',
        background: `url(${IconPrevArrow}) no-repeat`,
        backgroundSize: 'contain',
      }}
      onClick={onClick}
    />
  );
}

function CustomSlider(props) {
  const { data } = props;

  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  const [slider1, setSlider1] = useState(null);
  const [slider2, setSlider2] = useState(null);

  useEffect(() => {
    setNav1(slider1);
    setNav2(slider2);
  });

  const settingsMain = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    dots: true,
    autoplay: true,
    asNavFor: '.slider-nav',
  };

  const settingsThumbs = {
    slidesToShow: data.length > 4 ? 4 : data.length,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    dots: false,
    centerPadding: '10px',
    swipeToSlide: true,
    focusOnSelect: true,
    infinite: true,
    autoplay: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: data.length > 3 ? 3 : data.length,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
    ],
  };
  const customClass = data.length < 3 ? 'my-slick-slide' : '';

  return (
    <div className="App">
      <div className="slider-wrapper">
        <Slider {...settingsMain} asNavFor={nav2} ref={(slider) => setSlider1(slider)}>
          {data.map((slide, index) => (
            <div className="slick-slide wrap-custom-image" key={index}>
              <img className="slick-slide-image" src={slide?.image_url} />
            </div>
          ))}
        </Slider>
        <div
          className={`thumbnail-slider-wrap ${customClass} ${
            data.length === 1 ? 'thumbnail-padding' : ''
          }`}
        >
          <Slider {...settingsThumbs} asNavFor={nav1} ref={(slider) => setSlider2(slider)}>
            {data.map((slide, index) => (
              <div className="slick-thumb" key={index}>
                <img className="slick-slide-image" src={slide?.thumbnail_url} />
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
}

export default CustomSlider;
